import getLocaleStoreCode from '@garmin/locale-storecode';

/**
 * Returns the store code for a given locale
 * @param {string} locale - The locale to get the store code for
 * @returns {string}      - The store code for the given locale
 * @example
 * getStoreCode('en-US'); // 'US'
 */
export const getStoreCode = (locale) => getLocaleStoreCode(locale) || 'US';

export const getCountryAndStoreCode = (locale) => {
  if (!locale) {
    return { countryCode: undefined, storeCode: undefined };
  }

  const countryCode = locale?.split('-', 2)?.[1];
  const storeCode = getStoreCode(locale);

  return { countryCode, storeCode };
};
